import React from 'react';

import PartnerOffering, { PartnerOfferingProps } from './PartnerOffering';
import { OFFERINGS_FOR_PARTNERS } from './constants';

const PartnersHowSection = (): JSX.Element => {
  return (
    <article className="mt-48 border-0 border-t border-solid border-grayscale-beige px-16 pt-48 sm:mx-28 sm:px-0 md:pr-80 lg:mx-0 lg:mt-64 lg:pl-0 lg:pr-28 lg:pt-64">
      <header>
        <h2 className="my-0 text-center font-suisse-works text-headline-xs sm:text-headline-md">
          How we work with partners
        </h2>
      </header>
      <div className="mx-auto flex max-w-[600px] flex-col md:max-w-full">
        {OFFERINGS_FOR_PARTNERS.map(
          (props: PartnerOfferingProps): JSX.Element => (
            <PartnerOffering key={props.imageSrc} {...props} />
          )
        )}
      </div>
    </article>
  );
};

export default PartnersHowSection;
